// const SERVER_URL =
//   // "https://benode.dev.paraacrypto.com";
//   "https://backend.api.paraacrypto.com";
// // "https://6l5d36nh-8888.inc1.devtunnels.ms";
// // "http://20.186.114.113:8080/";
// // "http://192.168.29.154:8080";
// const FIREBLOCK_URL =
//   // "http://192.168.29.154:8082";
//   "https://wallet-backend.dev.paraacrypto.com";
/**
 * Configuration file for API endpoints
 *
 * Backend-Monorepo migration: all REST traffic now flows through the single
 * API Gateway. The legacy SERVER_URL / FIREBLOCK_URL / ORDER_URL variables
 * are kept as aliases of the gateway URL so any importer still hitting them
 * lands on the same host. New code should import API_GATEWAY_URL directly.
 *
 * Gateway routing:
 *   /admin/*                          → admin-service (3006)
 *   /user/*, /user/auth/*             → user/auth services
 *   /order, /trading-pairs, /gullak   → order-service
 *   /wallet, /user/wallet/*           → wallet-service
 *   /market                           → market-service
 */

const API_GATEWAY_URL =
  process.env.REACT_APP_API_GATEWAY_URL ||
  process.env.REACT_APP_SERVER_URL ||
  "https://prod-backend.paraacrypto.com";

const validateURL = (url) => {
  try {
    const urlObj = new URL(url);
    if (process.env.NODE_ENV === "production" && urlObj.protocol !== "https:") {
      console.warn(`Insecure URL detected: ${url}. HTTPS required in production.`);
      return false;
    }
    return true;
  } catch (error) {
    console.error(`Invalid URL: ${url}`, error);
    return false;
  }
};

if (process.env.NODE_ENV === "production" && !validateURL(API_GATEWAY_URL)) {
  console.error(`Configuration Error: Invalid or insecure API Gateway URL - ${API_GATEWAY_URL}`);
}

module.exports = {
  API_GATEWAY_URL,
  // Legacy aliases — every old reference now points at the unified gateway.
  SERVER_URL: API_GATEWAY_URL,
  FIREBLOCK_URL: API_GATEWAY_URL,
  ORDER_URL: API_GATEWAY_URL,
};
